import { t } from 'i18next';

import {
  ADD_TASK_LOCATION,
  ADD_TASK_LOCATION_FAILURE,
  ADD_TASK_LOCATION_SUCCESS,
  CLEAR_LINK_TASK_STATE,
  CLEAR_MASTER_TASK_STATE,
  CLEAR_NEW_TASK_STATE,
  ARCHIVE_TASK_LOCATION,
  ARCHIVE_TASK_LOCATION_FAILURE,
  ARCHIVE_TASK_LOCATION_SUCCESS,
  CLEAR_TASK_STATE,
  CREATE_LINK_TASK,
  CREATE_LINK_TASK_FAILURE,
  CREATE_LINK_TASK_SUCCESS,
  CREATE_MASTER_TASK,
  CREATE_MASTER_TASK_FAILURE,
  CREATE_MASTER_TASK_SUCCESS,
  CREATE_MAX_TASK_DURATION,
  CREATE_MAX_TASK_DURATION_FAILURE,
  CREATE_MAX_TASK_DURATION_SUCCESS,
  GET_MAX_TASK_DURATION,
  GET_MAX_TASK_DURATION_FAILURE,
  GET_MAX_TASK_DURATION_SUCCESS,
  CREATE_TASK,
  CREATE_TASK_FAILURE,
  CREATE_TASK_SUCCESS,
  DELETE_TASK,
  DELETE_TASK_FAILURE,
  DELETE_TASK_SUCCESS,
  DUPLICATE_TASK,
  DUPLICATE_TASK_FAILURE,
  DUPLICATE_TASK_SUCCESS,
  EDIT_TASK,
  EDIT_TASK_FAILURE,
  EDIT_TASK_SUCCESS,
  GET_MASTER_TASK,
  GET_MASTER_TASK_FAILURE,
  GET_MASTER_TASK_SUCCESS,
  GET_NEW_TASK,
  GET_NEW_TASK_FAILURE,
  GET_NEW_TASK_SUCCESS,
  GET_LOCATION_TYPE_LIST,
  GET_LOCATION_TYPE_LIST_FAILURE,
  GET_LOCATION_TYPE_LIST_SUCCESS,
  GET_TASKS_LIST,
  GET_TASKS_LIST_FAILURE,
  GET_TASKS_LIST_SUCCESS,
  GET_TASK_DETAILS,
  GET_TASK_DETAILS_FAILURE,
  GET_TASK_DETAILS_SUCCESS,
  GET_TASK_LOCATIONS,
  GET_TASK_LOCATIONS_FAILURE,
  GET_TASK_LOCATIONS_SUCCESS,
  GET_TASK_TYPE,
  GET_TASK_TYPE_FAILURE,
  GET_TASK_TYPE_SUCCESS,
  LOGIN_PROFILE_CREATED_RESET,
  UPDATE_TASK_LOCATION,
  UPDATE_TASK_LOCATION_FAILURE,
  UPDATE_TASK_LOCATION_SUCCESS,
  UPDATE_TASK_STATUS,
  UPDATE_TASK_STATUS_FAILURE,
  UPDATE_TASK_STATUS_SUCCESS,
  CLEAR_MAX_TASK_TIME,
  UPDATE_MASTER_TASK,
  UPDATE_MASTER_TASK_FAILURE,
  UPDATE_MASTER_TASK_SUCCESS,
  ARCHIVE_MASTER_TASK,
  ARCHIVE_MASTER_TASK_FAILURE,
  ARCHIVE_MASTER_TASK_SUCCESS,
  UNARCHIVE_MASTER_TASK,
  UNARCHIVE_MASTER_TASK_FAILURE,
  UNARCHIVE_MASTER_TASK_SUCCESS,
  EXPORT_TASKS,
  EXPORT_TASKS_SUCCESS,
  EXPORT_TASKS_FAILURE,
} from '../../modules/constants';
import { createNotification } from '../../modules/notificationManager';

const noInternetMsg =
  'No Internet Connection! Please connect to the internet and try again';

//get tasks list
export const getTasksListRequest = (state, action) => {
  return {
    ...state,
    isLoading: true,
  };
};
export const getTasksListRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 200) {
    return {
      ...state,
      isLoading: false,
      tasksList: data.data.results,
      tasksListCount: data.data.count,
      taskListPageSize: data.data.page_size,
    };
  }
  return {
    ...state,
    isLoading: false,
    tasksList: [],
    tasksListCount: null,
    taskListPageSize: null,
  };
};
export const getTasksListRequestFailure = (state, action) => {
  return {
    ...state,
    isLoading: false,
    tasksList: [],
    tasksListCount: null,
    taskListPageSize: null,
  };
};

// create task
export const createTaskRequest = (state, action) => {
  return {
    ...state,
    isLoading: true,
  };
};
export const createTaskRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data && data.status === 201) {
    createNotification('success', t('task_created_successfully'), 2000);
    return {
      ...state,
      isLoading: false,
      createdTaskInfo: data.data,
    };
  }
  return {
    ...state,
    isLoading: false,
    createdTaskInfo: null,
  };
};
export const createTaskRequestFailure = (state, action) => {
  const {
    payload: { response },
  } = action;
  if (
    response &&
    response.status === 400 &&
    response.data &&
    response.data.detail &&
    response.data.detail === 'employee has another task within the given time'
  ) {
    createNotification(
      'error',
      t(`employee_has_another_task_within_the_given_time`),
      5000,
    );
    return {
      ...state,
      isLoading: false,
      createdTaskInfo: null,
      overlap: true,
    };
  }
  if (action.payload.data === undefined) {
    createNotification('error', response.data.detail, 3000);
    return {
      ...state,
      isLoading: false,
      createdTaskInfo: null,
    };
  }
  const {
    payload: { data },
  } = action;
  if (data.status === 400) {
    createNotification(
      'error',
      'Sorry! could not create task. Please try again.',
      2000,
    );
  }
  return {
    ...state,
    isLoading: false,
    createdTaskInfo: null,
  };
};

// Create Master Task

export const createMasterTaskRequest = (state, action) => {
  return {
    ...state,
    isCreateMasterTaskLoading: true,
  };
};
export const createMasterTaskRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data && data.status === 201) {
    createNotification('success', 'Master Task created successfully', 2000);
    return {
      ...state,
      isCreateMasterTaskLoading: false,
      createdMasterTaskInfo: data.data,
    };
  }
  return {
    ...state,
    isCreateMasterTaskLoading: false,
    createdMasterTaskInfo: null,
  };
};
export const createMasterTaskRequestFailure = (state, action) => {
  const {
    payload: { response },
  } = action;
  if (action.payload.data === undefined) {
    createNotification('error', 'Something went Wrong.', 3000);
    return {
      ...state,
      isCreateMasterTaskLoading: false,
      createdMasterTaskInfo: null,
    };
  }
  const {
    payload: { data },
  } = action;
  if (data.status === 400) {
    createNotification(
      'error',
      'Sorry! could not create task. Please try again.',
      2000,
    );
  }
  return {
    ...state,
    isCreateMasterTaskLoading: false,
    createdMasterTaskInfo: null,
  };
};

// Create Max Task Duration

export const createMaxTaskDurationRequest = (state, action) => {
  return {
    ...state,
    isMaxTaskDurationLoading: true,
  };
};
export const createMaxTaskDurationRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data && data.status === 200) {
    createNotification('success', 'Max Task Time set successfully', 2000);
    return {
      ...state,
      isMaxTaskDurationLoading: false,
      maxTaskDurationInfo: data.data,
      fetchedMaxTaskDuration: data.data,
    };
  }
  return {
    ...state,
    isMaxTaskDurationLoading: false,
    maxTaskDurationInfo: null,
  };
};
export const createMaxTaskDurationRequestFailure = (state, action) => {
  const {
    payload: { response },
  } = action;
  if (action.payload.data === undefined) {
    createNotification('error', 'Something went Wrong.', 3000);
    return {
      ...state,
      isMaxTaskDurationLoading: false,
      maxTaskDurationInfo: null,
    };
  }
  const {
    payload: { data },
  } = action;
  if (data.status === 400) {
    createNotification(
      'error',
      'Sorry! could not set Max Task Time Duration. Please try again.',
      2000,
    );
  }
  return {
    ...state,
    isMaxTaskDurationLoading: false,
    maxTaskDurationInfo: null,
  };
};

//Link task

export const createLinkTaskRequest = (state, action) => {
  return {
    ...state,
    isLinkMasterTaskLoading: true,
  };
};
export const createLinkTaskRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data && data.status === 200) {
    createNotification('success', 'Task Linked successfully', 2000);
    return {
      ...state,
      isLinkMasterTaskLoading: false,
      createdLinkTaskInfo: data.data,
    };
  }
  return {
    ...state,
    isLinkMasterTaskLoading: false,
    createdLinkTaskInfo: null,
  };
};
export const createLinkTaskRequestFailure = (state, action) => {
  const {
    payload: { response },
  } = action;
  if (action.payload.data === undefined) {
    createNotification('error', 'Something went Wrong.', 3000);
    return {
      ...state,
      isLinkMasterTaskLoading: false,
      createdLinkTaskInfo: null,
    };
  }
  const {
    payload: { data },
  } = action;
  if (data.status === 400) {
    createNotification(
      'error',
      'Sorry! could not Linked Task. Please try again.',
      2000,
    );
  }
  return {
    ...state,
    isLinkMasterTaskLoading: false,
    createdLinkTaskInfo: null,
  };
};

// Task details by id
export const getTaskDetailsRequest = (state, action) => {
  return {
    ...state,
    isLoading: true,
  };
};
export const getTaskDetailsRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 200) {
    return {
      ...state,
      isLoading: false,
      taskDetails: data.data,
    };
  }
  return {
    ...state,
    isLoading: false,
    taskDetails: null,
  };
};
export const getTaskDetailsRequestFailure = (state, action) => {
  return {
    ...state,
    isLoading: false,
    taskDetails: null,
  };
};

//Get Master Task

export const getMasterTaskRequest = (state, action) => {
  return {
    ...state,
    isMasterTaskLoading: true,
  };
};
export const getMasterTaskRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 200) {
    return {
      ...state,
      isMasterTaskLoading: false,
      MasterTasks: data.data,
    };
  }
  return {
    ...state,
    isMasterTaskLoading: false,
    MasterTasks: null,
  };
};
export const getMasterTaskRequestFailure = (state, action) => {
  return {
    ...state,
    isMasterTaskLoading: false,
    MasterTasks: null,
  };
};

// get new tasks

export const getNewTaskRequest = (state, action) => {
  return {
    ...state,
    isNewTaskLoading: true,
  };
};
export const getNewTaskRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 200) {
    return {
      ...state,
      isNewTaskLoading: false,
      NewTasks: data.data,
    };
  }
  return {
    ...state,
    isNewTaskLoading: false,
    NewTasks: null,
  };
};
export const getNewTaskRequestFailure = (state, action) => {
  return {
    ...state,
    isNewTaskLoading: false,
    NewTasks: null,
  };
};

//edit task
export const editTaskRequest = (state, action) => {
  return {
    ...state,
    isLoading: true,
    callback: false,
  };
};
export const editTaskRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data && data.status === 200) {
    createNotification('success', t('task_updated_successfully'), 2000);
    return {
      ...state,
      isLoading: false,
      callback: true,
    };
  }
  return {
    ...state,
    isLoading: false,
    callback: false,
  };
};
export const editTaskRequestFailure = (state, action) => {
  const {
    payload: { response },
  } = action;
  if (
    response &&
    response.status === 400 &&
    response.data &&
    response.data.detail &&
    response.data.detail === 'employee has another task within the given time'
  ) {
    createNotification(
      'error',
      t(`employee_has_another_task_within_the_given_time`),
      5000,
    );
    return {
      ...state,
      isLoading: false,
      callback: false,
      overlap: true,
    };
  }
  if (action.payload.data === undefined) {
    createNotification('error', 'Something went wrong!', 2000);
    return {
      ...state,
      isLoading: false,
      callback: false,
    };
  }
  const {
    payload: { data },
  } = action;
  if (data.status === 400) {
    createNotification('error', 'Failed!! please try again', 2000);
  }
  return {
    ...state,
    isLoading: false,
    callback: false,
  };
};

//duplicate task
export const duplicateTaskRequest = (state, action) => {
  return {
    ...state,
    duplicateIsLoading: true,
  };
};
export const duplicateTaskRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data && data.status === 201) {
    createNotification('success', 'task duplicated successfully', 2000);
    return {
      ...state,
      duplicateIsLoading: false,
      duplicateTaskInfo: data.data,
    };
  }
  return {
    ...state,
    duplicateIsLoading: false,
    duplicateTaskInfo: null,
  };
};
export const duplicateTaskRequestFailure = (state, action) => {
  if (action.payload.data === undefined) {
    createNotification(
      'error',
      'No internet connection found. Please connect to the internet.',
      3000,
    );
    return {
      ...state,
      duplicateIsLoading: false,
      duplicateTaskInfo: null,
    };
  }
  const {
    payload: { data },
  } = action;
  if (data.status === 400) {
    createNotification(
      'error',
      'Sorry! could not duplicate task. Please try again.',
      2000,
    );
  }
  return {
    ...state,
    duplicateIsLoading: false,
    duplicateTaskInfo: null,
  };
};

//DELETE TASK
export const deleteTaskRequest = (state, action) => {
  return {
    ...state,
    deleteIsLoading: true,
    deletedCallback: false,
  };
};
export const deleteTaskRequestSuccess = (state, action) => {
  const {
    payload: { data, task_id },
  } = action;
  if (data && data.status === 204) {
    createNotification('success', 'task deleted successfully', 3000);

    let newList = JSON.parse(JSON.stringify(state.tasksList));
    if (state.tasksList && state.tasksList.length > 0 && task_id) {
      newList = newList.filter(task => task.id !== task_id);
    }
    return {
      ...state,
      deleteIsLoading: false,
      deletedCallback: true,
      tasksList: [...newList],
    };
  }
  return {
    ...state,
    deleteIsLoading: false,
    deletedCallback: false,
  };
};
export const deleteTaskRequestFailure = (state, action) => {
  createNotification('error', 'Could not delete task. Please try again!', 3000);
  return {
    ...state,
    deleteIsLoading: false,
    deletedCallback: false,
  };
};

//get task location
export const getTaskLocationsRequest = (state, action) => {
  return {
    ...state,
    createdTaskLocationInfo: null,
    locationListIsLoading: true,
  };
};
export const getTaskLocationsRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 200) {
    return {
      ...state,
      locationsList: data.data,
      locationListIsLoading: false,
    };
  }
  return {
    ...state,
    locationsList: [],
    locationListIsLoading: false,
  };
};
export const getTaskLocationsRequestFailure = (state, action) => {
  return {
    ...state,
    locationsList: [],
    locationListIsLoading: false,
  };
};

// Add task location
export const addTaskLocationRequest = (state, action) => {
  return {
    ...state,
    createdTaskLocationInfo: null,
    addTaskLocationLoading: true,
  };
};
export const addTaskLocationRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data && data.status === 201) {
    createNotification('success', t('task_location_added_successfully'), 2000);
    const currentList = JSON.parse(JSON.stringify(state.locationsList));
    return {
      ...state,
      addTaskLocationLoading: false,
      createdTaskLocationInfo: data.data,
      locationsList: [data.data, ...currentList],
    };
  }
  return {
    ...state,
    addTaskLocationLoading: false,
    createdTaskLocationInfo: null,
  };
};
export const addTaskLocationRequestFailure = (state, action) => {
  if (action.payload.data === undefined) {
    createNotification('error', 'There was an error. Please try again!', 3000);
    return {
      ...state,
      addTaskLocationLoading: false,
      createdTaskLocationInfo: null,
    };
  }
  const {
    payload: { data },
  } = action;
  if (data.status === 400) {
    createNotification(
      'error',
      'Sorry! could not add task location. Please try again.',
      2000,
    );
  }
  return {
    ...state,
    addTaskLocationLoading: false,
    createdTaskLocationInfo: null,
  };
};

export const taskUpdateRequestHandler = (state, action) => {
  return {
    ...state,
    isLoading: true,
  };
};
export const taskUpdateRequestSuccessHandler = (state, action) => {
  const {
    payload: { data, task_id },
  } = action;
  if (data && data.status === 200) {
    createNotification('success', t('task_updated_successfully'), 2000);
    const currentList = JSON.parse(JSON.stringify(state.tasksList));

    return {
      ...state,
      isLoading: false,
      tasksList: currentList.filter(task => task.id !== task_id),
    };
  }
  return {
    ...state,
    isLoading: false,
  };
};
export const taskUpdateRequestFailureHandler = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 400) {
    createNotification('error', 'Failed!! please try again', 2000);
  }
  return {
    ...state,
    isLoading: false,
  };
};

//get task type
export const getTaskTypeRequest = (state, action) => {
  return {
    ...state,
    taskTypeIsLoading: true,
  };
};
export const getTaskTypeRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 200) {
    return {
      ...state,
      taskTypeList: data.data,
      taskTypeIsLoading: false,
    };
  }
  return {
    ...state,
    taskTypeList: [],
    taskTypeIsLoading: false,
  };
};
export const getTaskTypeRequestFailure = (state, action) => {
  return {
    ...state,
    taskTypeList: [],
    taskTypeIsLoading: false,
  };
};

// update task location
export const updateTaskLocationRequestHandler = (state, action) => {
  return {
    ...state,
    updateTaskLocationLoading: true,
    updateTaskLocationError: null
  };
};
export const updateTaskLocationRequestSuccessHandler = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data && data.status === 200) {
    createNotification('success', t('task_location_updated_successfully'), 2000);

    // Update the locations list with the updated location
    const currentList = JSON.parse(JSON.stringify(state.locationsList));
    const updatedList = currentList.map(location =>
      location.id === data.data.id ? data.data : location
    );

    return {
      ...state,
      updateTaskLocationLoading: false,
      updateTaskLocationError: null,
      locationsList: updatedList
    };
  }
  return {
    ...state,
    updateTaskLocationLoading: false,
    updateTaskLocationError: null
  };
};
export const updateTaskLocationRequestFailureHandler = (state, action) => {
  const {
    payload: { response }
  } = action;

  let errorMessage = 'Failed to update location. Please try again.';

  // Handle specific error messages
  if (response?.status === 404) {
    errorMessage = 'Location not found.';
  } else if (response?.data?.detail) {
    errorMessage = response.data.detail;
  }

  createNotification('error', errorMessage, 3000);

  return {
    ...state,
    updateTaskLocationLoading: false,
    updateTaskLocationError: errorMessage
  };
};

// get location type list
export const getLocationTypeListRequest = (state, action) => {
  return {
    ...state,
    locationTypeListIsLoading: true,
  };
};
export const getLocationTypeListRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 200) {
    console.log("data", data.data);
    return {
      ...state,
      locationTypeList: data?.data,
      locationTypeListIsLoading: false,
    };
  }
  return {
    ...state,
    locationTypeList: [],
    locationTypeListIsLoading: false,
  };
};

export const getLocationTypeListRequestFailure = (state, action) => {
  return {
    ...state,
    locationTypeList: [],
    locationTypeListIsLoading: false,
  };
};



// clear state on logout
export const handleLogoutRequest = (state, action) => {
  return {
    ...state,
    ...initialState,
  };
};

//clear task state
export const clearTaskStateRequest = (state, action) => {
  return {
    ...state,
    callback: false,
    taskDetails: null,
    createdTaskInfo: null,
    overlap: false,
    createdTaskLocationInfo: null,
  };
};

//clear new task states
export const clearNewTaskStateRequest = (state, action) => {
  return {
    ...state,
    NewTasks: [],
  };
};

//clear Link task states
export const clearLinkTaskStateRequest = (state, action) => {
  return {
    ...state,
    createdLinkTaskInfo: null,
  };
};

export const clearMasterTaskStateRequest = (state, action) => {
  return {
    ...state,
    createdMasterTaskInfo: null,
  };
};

export const clearMaxTaskTimeStateRequest = (state, action) => {
  return {
    ...state,
    maxTaskDurationInfo: null,
  };
};

export const archiveTaskLocationHandler = (state) => {
  return {
    ...state,
    isArchiving: true,
  };
};

export const archiveTaskLocationSuccessHandler = (state, action) => {
  const {
    payload: { data, locationId },
  } = action;
  if (data && data.status === 200 || data && data.status === 204) {
    console.log("location_id", locationId);
    if(data && data.status === 204){
      // remove the location from the locationsList
      createNotification('success', t('task_location_archived_successfully'), 2000);
      const currentList = JSON.parse(JSON.stringify(state.locationsList));
      const newList = currentList.filter(location => location.id !== locationId);
      return {
        ...state,
        locationsList: newList,
        isArchiving: false
      };
    }
    let returnedData = data?.data;
    // remove the location from the locationsList
    const currentList = JSON.parse(JSON.stringify(state.locationsList));
    const newList = currentList.filter(location => location.id !== returnedData.id);
    createNotification('success',
      returnedData?.is_active ?
      t('task_location_unarchived_successfully') :
      t('task_location_archived_successfully')
      , 2000);
    return {
      ...state,
      locationsList: newList,
      isArchiving: false
    };
  }
  return {
    ...state,
    isArchiving: false
  };
};

export const archiveTaskLocationFailureHandler = (state, action) => {
  console.log('action.payload.response', action.payload.response);
  if(action.payload.response.data.detail){
    createNotification('error', action.payload.response.data.detail, 2000);
  }
  else{
    createNotification('error', 'Failed!! please try again', 2000);
  }
  return {
    ...state,
    isArchiving: false,
  };
};

// Update Master Task
export const updateMasterTaskRequest = (state, action) => {
  return {
    ...state,
    isUpdateMasterTaskLoading: true,
  };
};

export const updateMasterTaskRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data && data.status === 200) {
    createNotification('success', 'Master Task updated successfully', 2000);

    // Update the MasterTasks list
    const updatedMasterTasks = state.MasterTasks.map(task =>
      task.id === data.data.id ? data.data : task
    );

    return {
      ...state,
      isUpdateMasterTaskLoading: false,
      updatedMasterTaskInfo: data.data,
      MasterTasks: updatedMasterTasks,
    };
  }
  return {
    ...state,
    isUpdateMasterTaskLoading: false,
    updatedMasterTaskInfo: null,
  };
};

export const updateMasterTaskRequestFailure = (state, action) => {
  const {
    payload: { response },
  } = action;
  if (action.payload.data === undefined) {
    createNotification('error', 'Something went wrong.', 3000);
    return {
      ...state,
      isUpdateMasterTaskLoading: false,
      updatedMasterTaskInfo: null,
    };
  }

  createNotification(
    'error',
    'Sorry! Could not update Master Task. Please try again.',
    2000,
  );

  return {
    ...state,
    isUpdateMasterTaskLoading: false,
    updatedMasterTaskInfo: null,
  };
};

// Archive Master Task
export const archiveMasterTaskRequest = (state, action) => {
  return {
    ...state,
    isArchiving: true,
  };
};

export const archiveMasterTaskRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data && data.status === 200) {
    createNotification('success', 'Master Task archived successfully', 2000);

    // Filter out the archived task from MasterTasks list
    const updatedMasterTasks = state.MasterTasks.filter(task =>
      task.id !== data.data.id
    );

    return {
      ...state,
      isArchiving: false,
      archivedMasterTaskInfo: data.data,
      MasterTasks: updatedMasterTasks,
    };
  }
  return {
    ...state,
    isArchiving: false,
    archivedMasterTaskInfo: null,
  };
};

export const archiveMasterTaskRequestFailure = (state, action) => {
  const {
    payload: { response },
  } = action;
  if (action.payload.data === undefined) {
    createNotification('error', 'Something went wrong.', 3000);
    return {
      ...state,
      isArchiving: false,
      archivedMasterTaskInfo: null,
    };
  }

  createNotification(
    'error',
    'Sorry! Could not archive Master Task. Please try again.',
    2000,
  );

  return {
    ...state,
    isArchiving: false,
    archivedMasterTaskInfo: null,
  };
};

// Unarchive Master Task
export const unarchiveMasterTaskRequest = (state, action) => {
  return {
    ...state,
    isUnarchiving: true,
  };
};

export const unarchiveMasterTaskRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data && data.status === 200) {
    createNotification('success', 'Master Task unarchived successfully', 2000);

    // Return updated state with unarchived task info
    return {
      ...state,
      unarchivedMasterTaskInfo: data.data,
      isUnarchiving: false,
    };
  }
  return {
    ...state,
    isUnarchiving: false,
    unarchivedMasterTaskInfo: null,
  };
};

export const unarchiveMasterTaskRequestFailure = (state, action) => {
  const {
    payload: { response },
  } = action;
  if (action.payload.data === undefined) {
    createNotification('error', 'Something went wrong.', 3000);
    return {
      ...state,
      isUnarchiving: false,
      unarchivedMasterTaskInfo: null,
    };
  }

  createNotification(
    'error',
    'Sorry! Could not unarchive Master Task. Please try again.',
    2000,
  );

  return {
    ...state,
    isUnarchiving: false,
    unarchivedMasterTaskInfo: null,
  };
};

// Fetch max task duration
export const getMaxTaskDurationRequest = (state) => {
  return {
    ...state,
    isMaxTaskDurationLoading: true,
    fetchedMaxTaskDuration: null,
  };
};

export const getMaxTaskDurationRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data && data.status === 200) {
    return {
      ...state,
      isMaxTaskDurationLoading: false,
      fetchedMaxTaskDuration: data.data,
    };
  }
  return {
    ...state,
    isMaxTaskDurationLoading: false,
    fetchedMaxTaskDuration: null,
  };
};

export const getMaxTaskDurationRequestFailure = (state) => {
  return {
    ...state,
    isMaxTaskDurationLoading: false,
    fetchedMaxTaskDuration: null,
  };
};

// Export Tasks
export const exportTasksRequest = (state, action) => {
  return {
    ...state,
    exportLoading: true,
  };
};

export const exportTasksRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 200) {
    return {
      ...state,
      exportLoading: false,
    };
  }
  return {
    ...state,
    exportLoading: false,
  };
};

export const exportTasksRequestFailure = (state, action) => {
  return {
    ...state,
    exportLoading: false,
  };
};

// Action Handlers
const ACTION_HANDLERS = {
  [GET_TASKS_LIST]: getTasksListRequest,
  [GET_TASKS_LIST_SUCCESS]: getTasksListRequestSuccess,
  [GET_TASKS_LIST_FAILURE]: getTasksListRequestFailure,

  [CREATE_TASK]: createTaskRequest,
  [CREATE_TASK_SUCCESS]: createTaskRequestSuccess,
  [CREATE_TASK_FAILURE]: createTaskRequestFailure,

  [CREATE_MASTER_TASK]: createMasterTaskRequest,
  [CREATE_MASTER_TASK_SUCCESS]: createMasterTaskRequestSuccess,
  [CREATE_MASTER_TASK_FAILURE]: createMasterTaskRequestFailure,

  [CREATE_LINK_TASK]: createLinkTaskRequest,
  [CREATE_LINK_TASK_SUCCESS]: createLinkTaskRequestSuccess,
  [CREATE_LINK_TASK_FAILURE]: createLinkTaskRequestFailure,

  [GET_TASK_DETAILS]: getTaskDetailsRequest,
  [GET_TASK_DETAILS_SUCCESS]: getTaskDetailsRequestSuccess,
  [GET_TASK_DETAILS_FAILURE]: getTaskDetailsRequestFailure,

  [GET_MASTER_TASK]: getMasterTaskRequest,
  [GET_MASTER_TASK_SUCCESS]: getMasterTaskRequestSuccess,
  [GET_MASTER_TASK_FAILURE]: getMasterTaskRequestFailure,

  [GET_MAX_TASK_DURATION]: getMaxTaskDurationRequest,
  [GET_MAX_TASK_DURATION_SUCCESS]: getMaxTaskDurationRequestSuccess,
  [GET_MAX_TASK_DURATION_FAILURE]: getMaxTaskDurationRequestFailure,

  //new tasks
  [GET_NEW_TASK]: getNewTaskRequest,
  [GET_NEW_TASK_SUCCESS]: getNewTaskRequestSuccess,
  [GET_NEW_TASK_FAILURE]: getNewTaskRequestFailure,

  [EDIT_TASK]: editTaskRequest,
  [EDIT_TASK_SUCCESS]: editTaskRequestSuccess,
  [EDIT_TASK_FAILURE]: editTaskRequestFailure,

  [DUPLICATE_TASK]: duplicateTaskRequest,
  [DUPLICATE_TASK_SUCCESS]: duplicateTaskRequestSuccess,
  [DUPLICATE_TASK_FAILURE]: duplicateTaskRequestFailure,

  [DELETE_TASK]: deleteTaskRequest,
  [DELETE_TASK_SUCCESS]: deleteTaskRequestSuccess,
  [DELETE_TASK_FAILURE]: deleteTaskRequestFailure,

  [GET_TASK_LOCATIONS]: getTaskLocationsRequest,
  [GET_TASK_LOCATIONS_SUCCESS]: getTaskLocationsRequestSuccess,
  [GET_TASK_LOCATIONS_FAILURE]: getTaskLocationsRequestFailure,

  [ADD_TASK_LOCATION]: addTaskLocationRequest,
  [ADD_TASK_LOCATION_SUCCESS]: addTaskLocationRequestSuccess,
  [ADD_TASK_LOCATION_FAILURE]: addTaskLocationRequestFailure,

  [CREATE_MAX_TASK_DURATION]: createMaxTaskDurationRequest,
  [CREATE_MAX_TASK_DURATION_SUCCESS]: createMaxTaskDurationRequestSuccess,
  [CREATE_MAX_TASK_DURATION_FAILURE]: createMaxTaskDurationRequestFailure,

  [UPDATE_TASK_STATUS]: taskUpdateRequestHandler,
  [UPDATE_TASK_STATUS_SUCCESS]: taskUpdateRequestSuccessHandler,
  [UPDATE_TASK_STATUS_FAILURE]: taskUpdateRequestFailureHandler,

  [GET_TASK_TYPE]: getTaskTypeRequest,
  [GET_TASK_TYPE_SUCCESS]: getTaskTypeRequestSuccess,
  [GET_TASK_TYPE_FAILURE]: getTaskTypeRequestFailure,

  [UPDATE_TASK_LOCATION]: updateTaskLocationRequestHandler,
  [UPDATE_TASK_LOCATION_SUCCESS]: updateTaskLocationRequestSuccessHandler,
  [UPDATE_TASK_LOCATION_FAILURE]: updateTaskLocationRequestFailureHandler,

  [GET_LOCATION_TYPE_LIST]: getLocationTypeListRequest,
  [GET_LOCATION_TYPE_LIST_SUCCESS]: getLocationTypeListRequestSuccess,
  [GET_LOCATION_TYPE_LIST_FAILURE]: getLocationTypeListRequestFailure,

  [CLEAR_TASK_STATE]: clearTaskStateRequest,
  [CLEAR_NEW_TASK_STATE]: clearNewTaskStateRequest,
  [CLEAR_MASTER_TASK_STATE]: clearMasterTaskStateRequest,
  [CLEAR_LINK_TASK_STATE]: clearLinkTaskStateRequest,

  [LOGIN_PROFILE_CREATED_RESET]: handleLogoutRequest,
  [CLEAR_MAX_TASK_TIME]:clearMaxTaskTimeStateRequest,

  [ARCHIVE_TASK_LOCATION]: archiveTaskLocationHandler,
  [ARCHIVE_TASK_LOCATION_SUCCESS]: archiveTaskLocationSuccessHandler,
  [ARCHIVE_TASK_LOCATION_FAILURE]: archiveTaskLocationFailureHandler,

  // Update Master Task
  [UPDATE_MASTER_TASK]: updateMasterTaskRequest,
  [UPDATE_MASTER_TASK_SUCCESS]: updateMasterTaskRequestSuccess,
  [UPDATE_MASTER_TASK_FAILURE]: updateMasterTaskRequestFailure,

  // Archive Master Task
  [ARCHIVE_MASTER_TASK]: archiveMasterTaskRequest,
  [ARCHIVE_MASTER_TASK_SUCCESS]: archiveMasterTaskRequestSuccess,
  [ARCHIVE_MASTER_TASK_FAILURE]: archiveMasterTaskRequestFailure,

  // Unarchive Master Task
  [UNARCHIVE_MASTER_TASK]: unarchiveMasterTaskRequest,
  [UNARCHIVE_MASTER_TASK_SUCCESS]: unarchiveMasterTaskRequestSuccess,
  [UNARCHIVE_MASTER_TASK_FAILURE]: unarchiveMasterTaskRequestFailure,

  [EXPORT_TASKS]: exportTasksRequest,
  [EXPORT_TASKS_SUCCESS]: exportTasksRequestSuccess,
  [EXPORT_TASKS_FAILURE]: exportTasksRequestFailure,
};

// default initial state
const initialState = {
  // task
  isLoading: false,
  duplicateIsLoading: false,
  deleteIsLoading: false,

  // archive task location
  isArchiving: false,
  isUnarchiving: false,
  // location
  locationListIsLoading: false,
  addTaskLocationLoading: false,
  updateTaskLocationLoading: false,
  getLocationTypeListLoading: false,
  locationTypeList: [],

  // task type
  taskTypeIsLoading: false,

  callback: false,
  deletedCallback: false,
  tasksList: [],
  taskDetails: null,
  createdTaskInfo: null,
  overlap: false,
  duplicateTaskInfo: null,
  locationsList: [],
  createdTaskLocationInfo: null,
  taskTypeList: [],
  // pagination
  tasksListCount: null,
  taskListPageSize: null,
  //Master Task
  isMasterTaskLoading: false,
  MasterTasks: [],
  // create master task
  isCreateMasterTaskLoading: false,
  createdMasterTaskInfo: null,

  //new tasks
  isNewTaskLoading: false,
  NewTasks: [],

  //link task
  isLinkMasterTaskLoading: false,
  createdLinkTaskInfo: null,
  //max task time
  isMaxTaskDurationLoading: false,
  maxTaskDurationInfo: null,
  fetchedMaxTaskDuration: null,
  updateTaskLocationError: null,
  exportLoading: false,
};

export default function tasksReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}
